export const handleSetBackdropLoading = (isLoading) => ({
    type: 'SET_BACKDROP_LOADING', isLoading
});